import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PurposeSummary.css';

export default class PurposeSummary extends Component {
  static propTypes = {
    lines: PropTypes.array,
  }

  render() {
    const { lines } = this.props;

    return (
      <section className="purpose-summary">
        <p>
          <em>Figure out what you want</em>, and <em>learn how to ask for it</em>. We’ll do the rest.
        </p>
        <ul>
          <li>Know yourself</li>
          <li>Desire growth</li>
          <li>Have intent and purpose</li>
        </ul>
        <ul>
          <li>Communicate</li>
          <li>Give feedback</li>
          <li>Be open</li>
          <li>Be vulnerable</li>
        </ul>
        <ul>
          <li>Support</li>
          <li>Development</li>
          <li>Tools</li>
          <li>Resources/training</li>
          <li>Coaching</li>
          <li>Snacks</li>
        </ul>
      </section>
    );
  }
}
